export default `
    id
    title
`;
